import { dataLayerPush } from '../../../util/GA/googleTagManager/dataLayer.js';
import { queryString } from '../../../util/location-helpers.js';
import {isNotNullOrWhitespace} from '../../../util/empty-helpers';

export default class {
  constructor(context) {
    // Set Context
    this._context = context;
    this._url = null;
    this._urlParams = null;

    // Initialise component
    this.init();
  }

  init() {
    let urlParams = queryString();
    if (!urlParams || !isNotNullOrWhitespace(urlParams.icid) || !isNotNullOrWhitespace(urlParams.icidtitle)) return;

    this._urlParams = urlParams;
    this.handleViewPage();

    let eventButton = this._context.querySelector('[data-sale-button]');
    if (eventButton) {
      this._url = eventButton.href;
      eventButton.addEventListener('click', e => this.handleClick(e));
    }
  }

  handleViewPage() {
    let gaDataStructure = {
      'event': 'promotionView',
      'ecommerce': {
        'promoView': {
          'promotions': [
            {
             'id': this._urlParams.icidtitle,
             'name': this._urlParams.icidtitle
            }
          ]
        }
      }
    }
    dataLayerPush(gaDataStructure, false);
  }

  handleClick(event) {
    event.preventDefault();

    let gaDataStructure = {
      'event': 'promotionClick',
      'ecommerce': {
        'promoClick': {
          'promotions': [
            {
             'id': this._urlParams.icidtitle,
             'name': this._urlParams.icidtitle
            }
          ]
        }
      },
      'eventCallback': () => {
        document.location = this._url;
      }
    }
    dataLayerPush(gaDataStructure, false);
  }
}
